/**
 * Utility class for generating file names with timestamps
 */
export class FileNameGenerator {
  /**
   * Generates a file name with timestamp
   */
  static generate(prefix: string): string {
    const agora = new Date();
    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, '0');
    const dia = String(agora.getDate()).padStart(2, '0');
    const hora = String(agora.getHours()).padStart(2, '0');
    const minuto = String(agora.getMinutes()).padStart(2, '0');
    const timestamp = `${ano}${mes}${dia}${hora}${minuto}`;
    return `${prefix}${timestamp}`;
  }
}
